import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../../../store/authStore'
import { supabase } from '../../../lib/supabase'

export const useBirthdays = () => {
  const household = useAuthStore((s) => s.household)
  const qc        = useQueryClient()
  const key       = ['birthdays', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('birthdays')
        .select('id, name, birth_date, notes, created_by')
        .eq('household_id', household.id)
        .order('birth_date')
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  const addBirthday = useMutation({
    mutationFn: async ({ name, birth_date, notes }) => {
      const { data: { session } } = await supabase.auth.getSession()
      const { error } = await supabase
        .from('birthdays')
        .insert({ household_id: household.id, name, birth_date, notes: notes || null, created_by: session.user.id })
      if (error) throw error
    },
    onSuccess: inv,
  })

  const updateBirthday = useMutation({
    mutationFn: async ({ id, name, birth_date, notes }) => {
      const { error } = await supabase
        .from('birthdays')
        .update({ name, birth_date, notes: notes || null })
        .eq('id', id)
      if (error) throw error
    },
    onSuccess: inv,
  })

  const deleteBirthday = useMutation({
    mutationFn: async (id) => {
      const { error } = await supabase.from('birthdays').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: inv,
  })

  return { ...query, addBirthday, updateBirthday, deleteBirthday }
}
